import python from "../assets/img/skills/python_logo.svg";
import ds from "../assets/img/skills/data_science_logo.svg";
import ml from "../assets/img/skills/ml_logo.svg";
import da from "../assets/img/skills/data_analysis_logo.svg";
import dv from "../assets/img/skills/data_visual_logo.svg";
import wd from "../assets/img/skills/web_dev_logo.svg";
import cj from "../assets/img/skills/java_logo.svg";
import cc from "../assets/img/skills/c_or_c_plus_logo.svg";
import rjs from "../assets/img/skills/reactjs_logo.svg";
import mysql from "../assets/img/skills/mysql_logo.svg";
import hcj from "../assets/img/skills/html_css_js_logo.svg";
import manage from "../assets/img/skills/management_logo.svg";
import prob from "../assets/img/skills/problem_solve_logo.svg";
import scikitl from "../assets/img/skills/scikit_learn_logo.svg";
import opencv from "../assets/img/skills/opencv_logo.svg";
import pythonlib from "../assets/img/skills/python_lib_logo.svg";
import math from "../assets/img/skills/maths_logo.svg";

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png"

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  const responsive_tech = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 6
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                      <h2>Skills</h2>
                      <p>I am professional in Python, Data Analytics, Data Science, AI-ML and Familiar with above Technologies.<br></br>My skills encompass developing innovative techniques in the modern AI world.</p>
                      <Carousel responsive={responsive} infinite={true} autoPlay={true} autoPlaySpeed={0} transitionDuration={3000} removeArrowOnDeviceType={["tablet", "mobile"]} className="owl-carousel owl-theme skill-slider">
                          <div className="item">
                              <img src={ds} alt="Image" />
                              <h5>Data Science</h5>
                          </div>
                          <div className="item">
                              <img src={ml} alt="Image" />
                              <h5>Machine Learning</h5>
                          </div>
                          <div className="item">
                              <img src={da} alt="Image" />
                              <h5>Data Analysis</h5>
                          </div>
                          <div className="item">
                              <img src={dv} alt="Image" />
                              <h5>Data Visualization</h5>
                          </div>
                          <div className="item">
                              <img src={wd} alt="Image" />
                              <h5>Web Development</h5>
                          </div>
                          <div className="item">
                              <img src={manage} alt="Image" />
                              <h5>Time & Project Management</h5>
                          </div>
                          <div className="item">
                              <img src={prob} alt="Image" />
                              <h5>Problem Solving</h5>
                          </div>
                      </Carousel>
                    
                      <h2 className="technologies-h2">Technologies</h2>
                      <p></p>
                      <Carousel responsive={responsive_tech} infinite={true} autoPlay={true} autoPlaySpeed={0} transitionDuration={3000} removeArrowOnDeviceType={["tablet", "mobile"]} className="owl-carousel owl-theme skill-slider">
                          <div className="item">
                              <img src={python} alt="Image" />
                              <h6>Python</h6>
                          </div>
                          <div className="item">
                              <img src={cj} alt="Image" />
                              <h6>Core Java</h6>
                          </div>
                          <div className="item">
                              <img src={cc} alt="Image" />
                              <h6>C/C++</h6>
                          </div>
                          <div className="item">
                              <img src={hcj} alt="Image" />
                              <h6>HTML, CSS & JS</h6>
                          </div>
                          <div className="item">
                              <img src={rjs} alt="Image" />
                              <h6>ReactJS</h6>
                          </div>
                          <div className="item">
                              <img src={mysql} alt="Image" />
                              <h6>MySQL</h6>
                          </div>
                          <div className="item">
                              <img src={scikitl} alt="Image" />
                              <h6>Scikit Learn</h6>
                          </div>
                          <div className="item">
                              <img src={opencv} alt="Image" />
                              <h6>OpenCV</h6>
                          </div>
                          <div className="item">
                              <img src={pythonlib} alt="Image" />
                              <h6>Python Libraries</h6>
                          </div>
                          <div className="item">
                              <img src={math} alt="Image" />
                              <h6>Mathematics</h6>
                          </div>
                      </Carousel>
                    </div>

                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}
